import Api from "shared/service/api/api";

// actions
export const LOAD_SERVICES = "loadServices";
export const LOAD_INVOICES = "loadInvoices";

//mutations
export const SET_SERVICES = "setServices";
export const SET_INVOICES = "setInvoices";

const state = {
  services: [],
  invoices: [],
};

const actions = {
  [LOAD_SERVICES]: ({ commit }) =>
    Api.tariffication.service
      .all()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_SERVICES, response.data);
      })
      .catch((e) => e),
  [LOAD_INVOICES]: ({ commit }) =>
    Api.tariffication.invoice
      .all()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_INVOICES, response.data);
      })
      .catch((e) => e),
};

const mutations = {
  [SET_SERVICES]: (state, data) => (state.services = data),
  [SET_INVOICES]: (state, data) => (state.invoices = data),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
